import { render } from "./ExtranetCorporateForm.vue?vue&type=template&id=4a75afa0&scoped=true"
import script from "./ExtranetCorporateForm.vue?vue&type=script&lang=js"
export * from "./ExtranetCorporateForm.vue?vue&type=script&lang=js"

import "./ExtranetCorporateForm.vue?vue&type=style&index=0&id=4a75afa0&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a75afa0"]])

export default __exports__